import {useEffect, useState} from 'react';
import classNames from 'classnames';
import {useCart} from '@shopify/hydrogen';

import Footer from './Footer.client';

import {useCartUI} from './CartUIProvider.client';
import Cart from './Cart.client';
import CartToggle from './CartToggle.client';
import LayoutBackground from 'shared/components/LayoutBackground';
import {PublicPageQueryResultThemeSettings} from 'graphql/queries/LinkpopQuery';

enum ShowFooterState {
  Loading = 'loading',
  Regular = 'regular',
}

interface LayoutProps {
  children: React.ReactNode;
  themeSettings: PublicPageQueryResultThemeSettings;
}

export default function Layout({children, themeSettings}: LayoutProps) {
  const {isCartOpen, closeCart} = useCartUI();
  const {totalQuantity} = useCart();

  const [showFooterState, setShowFooterState] = useState(
    ShowFooterState.Loading,
  );

  useEffect(() => {
    if (showFooterState === ShowFooterState.Loading) {
      setShowFooterState(ShowFooterState.Regular);
    }
  }, [showFooterState]);

  return (
    <div
      className={classNames(
        'max-w-screen',
        'min-h-screen',
        'font-sans',
        'text-gray-700',
        'flex',
        'flex-col',
      )}
      style={{
        color: themeSettings.fontColor,
        fontFamily: themeSettings.primaryFont,
      }}
    >
      <LayoutBackground themeSettings={themeSettings} />

      <div>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div
          className={classNames(
            'duration-400',
            'fixed',
            'top-0',
            'bottom-0',
            'left-0',
            'right-0',
            'z-50',
            'bg-black',
            'transition-opacity',
            isCartOpen ? 'opacity-20' : 'pointer-events-none opacity-0',
          )}
          onClick={isCartOpen ? closeCart : undefined}
        />
        <Cart />
      </div>

      {totalQuantity > 0 && (
        <div className={classNames('fixed', 'bottom-10', 'right-10', 'z-20')}>
          <CartToggle />
        </div>
      )}

      <main
        role="main"
        id="mainContent"
        className={classNames('relative', 'flex-1')}
      >
        <div
          className={classNames(
            'mx-auto',
            'max-w-3xl',
            'p-4',
            'md:py-5',
            'md:px-8',
          )}
        >
          {children}
        </div>
      </main>

      {showFooterState === ShowFooterState.Regular && (
        <Footer color={themeSettings.fontColor} />
      )}
    </div>
  );
}
